import { render, staticRenderFns } from "./Opened.vue?vue&type=template&id=895b0abe&scoped=true&"
import script from "./Opened.vue?vue&type=script&lang=js&"
export * from "./Opened.vue?vue&type=script&lang=js&"
import style0 from "./Opened.vue?vue&type=style&index=0&id=895b0abe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895b0abe",
  null
  
)

export default component.exports